import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { FormattedMessage } from 'react-intl';
import { useParams } from 'react-router-dom';
import ArrayUtil from '../../../utils/ArrayUtil';
import Boundary from '../../../components/ErrorBoundary';
import { updateTeamReportAssessments } from '../../../services/apps/TeamReportService';
import MembersListContainer from './MembersListContainer';
import { growlErrors } from '../../../utils/NotificationUtil';
import { AccountContext } from '../../../components/AccountContext';
import { NotificationContext } from '../../../components/GrowlNotifications';
import useSubscriptionExpiredRestrictions from '../../../hooks/useSubscriptionExpiredRestrictions';

const MembersEdit = ({ assessmentIds, hideModal, remount, modalOpen, modalName, template }) => {
  const [selectedTeams, setSelectedTeams] = useState(assessmentIds);

  const currentAccount = useContext(AccountContext);
  const growl = useContext(NotificationContext);
  const { subscriptionIsExpired } = useSubscriptionExpiredRestrictions();

  const { reportId } = useParams();

  const saveMngTeam = async () => {
    hideModal();
    try {
      await updateTeamReportAssessments({
        teamReportId: reportId,
        accountId: currentAccount,
        assessmentIds: selectedTeams,
      });
      remount();
    } catch (errors) {
      growlErrors(growl, errors);
    }
  };

  const selectSpecTeam = (id) => {
    if (ArrayUtil.isNotEmpty(selectedTeams) && selectedTeams.indexOf(id) >= 0) {
      const newSelections = selectedTeams.filter((selected) => selected !== id);
      setSelectedTeams(newSelections);
    } else {
      setSelectedTeams([...selectedTeams, id]);
    }
  };

  const isAllChecked = (data) => {
    if (ArrayUtil.isNotEmpty(data) && ArrayUtil.isNotEmpty(selectedTeams)) {
      const unSelectItem = data.filter((item) => selectedTeams.indexOf(item.id) < 0);
      if (ArrayUtil.isEmpty(unSelectItem)) {
        return true;
      }
    }

    return false;
  };

  const addAllTeams = async (isChecked, responseData) => {
    if (!isChecked) {
      if (ArrayUtil.isNotEmpty(responseData)) {
        const newSelections = responseData.filter((seletion) => selectedTeams.indexOf(seletion.id) < 0);
        if (ArrayUtil.isNotEmpty(newSelections)) {
          const selectionIdList = newSelections.map((selection) => selection.id);
          const newSelectedTeams = [...selectedTeams, ...selectionIdList];
          setSelectedTeams(newSelectedTeams);
        }
      }
    } else if (ArrayUtil.isNotEmpty(responseData) && ArrayUtil.isNotEmpty(selectedTeams)) {
      const removedIdList = responseData.map((selection) => selection.id);
      const newSelections = selectedTeams.filter((seletion) => removedIdList.indexOf(seletion) < 0);
      setSelectedTeams(newSelections);
    }
  };

  const footer = (
    <div className="p-grid">
      <div className="p-col-12 align-left">
        <FormattedMessage id="actions.cancel" defaultMessage="Cancel">
          {(text) => <Button type="button" label={text} className="p-button-secondary" onClick={hideModal} />}
        </FormattedMessage>
        &nbsp;
        <FormattedMessage id="actions.save" defaultMessage="Save">
          {(text) => <Button type="button" label={text} onClick={saveMngTeam} disabled={subscriptionIsExpired} />}
        </FormattedMessage>
      </div>
    </div>
  );
  return (
    <div className="p-grid">
      <Dialog
        header={modalName}
        footer={footer}
        visible={modalOpen}
        modal
        onHide={hideModal}
        maximizable
        resizable
        contentStyle={{ maxHeight: '30vw', overflow: 'auto' }}
      >
        <Boundary>
          <MembersListContainer
            templateId={template}
            selectedTeams={selectedTeams}
            selectSpecTeam={selectSpecTeam}
            addAllTeams={addAllTeams}
            isAllChecked={isAllChecked}
          />
        </Boundary>
      </Dialog>
    </div>
  );
};

MembersEdit.propTypes = {
  template: PropTypes.string.isRequired,
  assessmentIds: PropTypes.objectOf(PropTypes.any).isRequired,
  hideModal: PropTypes.func.isRequired,
  remount: PropTypes.func.isRequired,
  modalOpen: PropTypes.bool.isRequired,
  modalName: PropTypes.string.isRequired,
};

export default MembersEdit;
